import { render, staticRenderFns } from "./DetailHealth.vue?vue&type=template&id=6f62dd42&"
import script from "./DetailHealth.vue?vue&type=script&lang=js&"
export * from "./DetailHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports